// extracted by mini-css-extract-plugin
export var content = "_s3-1";
export var wrapper = "_s3-0";